import {ref, Ref} from "vue"

const isDisplayPaymentErrorPopup: Ref<boolean> = ref(false)

export default isDisplayPaymentErrorPopup